@if (!useDetailView) {
  <div class="card" #proposalItemsContainer>
    <div class="card-header font-weight-bold">Items</div>
    <div class="card-body">
      <form [formGroup]="formItems">
        @if (alertInfo.show) {
          <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
            {{ alertInfo.message }}
          </ngb-alert>
        }
        <div class="alert alert-warning">
          <strong>Notice!</strong> Before adding prices keep in mind that you could have some files in "Other Agreement"
          section.
        </div>
        @for (item of getItemsArray().controls; track item; let itemIndex = $index) {
          <div class="row align-items-start mx-3 py-3 items-list bg-light form-row"
            >
            @if (item) {
              <div class="col-sm-12">
                <div class="row g-3 align-items-center mt-0">
                  @if (isTechApprovalState) {
                    <div class="col-sm-1">
                      <switch-field [isChecked]="item.get('isVerifiedTechApproval')?.value" [message]="'Verified Tech'"
                        [readonly]="readonlyItems || !canModifyVerifiedTechSwitch" [item]="item" (isCheckedChange)="onSwitchChange($event)">
                      </switch-field>
                    </div>
                  }
                  @if (isOverdiscountApprovalState && isDiscountWarning(item)) {
                    <div class="col-sm-1">
                      <switch-field [isChecked]="item.get('isVerifiedOverdiscount')?.value" [message]="'Verified'"
                        [readonly]="readonlyItems || !canModifyVerifiedSwitch" [item]="item" (isCheckedChange)="onOverdiscountSwitchChange($event)">
                      </switch-field>
                    </div>
                  }
                  <div class="col-sm-1 d-flex align-items-center flex-column">
                    <label class="fw-bold">N. {{ itemIndex + 1 }}</label>
                    <button type="button" class="btn btn-danger" (click)="confirmDelete(getItemsArray(), itemIndex, 'Item')"
                      [disabled]="readonlyItems" [ngClass]="{'disabled': readonlyItems}">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div [ngClass]="(isTechApprovalState || isOverdiscountApprovalState) ? 'col-sm-3' : 'col-sm-4'">
                    <select-field [selectFormControl]="getFormControl(item, 'jurisdiction')" label="Jurisdiction"
                      [options]="jurisdictionsOptions" [readonly]="readonlyItems"
                      (selectionChange)="onJurisdictionChange(item)" />
                  </div>
                  <div [ngClass]="(isTechApprovalState || isOverdiscountApprovalState) ? 'col-sm-3' : 'col-sm-4'">
                    <select-field [selectFormControl]="getFormControl(item, 'itemProduct')" label="Product"
                      [options]="getProductOptionsForItem(itemIndex)" [readonly]="readonlyItems" />
                  </div>
                  <div class="col-sm-3">
                    <select-field [selectFormControl]="getFormControl(item, 'itemType')" label="Type"
                      [options]="getTypeOptionsForItem(itemIndex)" [readonly]="readonlyItems" />
                  </div>
                  <div class="row align-items-center">
                    @if (canSeePlatformField) {
                      <div class="col-sm-2">
                        <select-field [selectFormControl]="getFormControl(item, 'platformId')" label="Platform"
                          [options]="platformOptions" [readonly]="readonlyItems" />
                      </div>
                    }
                    <div class="col-sm-auto maxw-field">
                      <input-field type="number" [inputFormControl]="getFormControl(item, 'quantity')" label="Q.ty"
                        placeholder="1" [readonly]="readonlyItems" />
                    </div>
                    <div class="col-sm-auto maxw-field effort-field">
                      <input-field type="number" [inputFormControl]="getFormControl(item, 'effort')" label="Effort"
                        placeholder="100" [readonly]="readonlyItems" suffix="%" />
                    </div>
                    <div class="col-sm-3 col-xl-4 col-xxl-5">
                      <input-field type="text" [inputFormControl]="getFormControl(item, 'detail')" label="Details"
                        placeholder="Details" [readonly]="readonlyItems" />
                    </div>
                  </div>
                  @if (canViewPricingFields) {
                    <div class="row align-items-start mt-2">
                      <div class="col-sm-3 col-xxl-4">
                        <select-field [selectFormControl]="getFormControl(item, 'campaignId')" label="Promo"
                          [options]="campaignsOptions" [readonly]="readonlyItems" />
                      </div>
                      <div class="col-sm-2 maxw-field price-field">
                        <input-field type="number" [inputFormControl]="getFormControl(item, 'price')" label="Price"
                          placeholder="600.00" [readonly]="readonlyItems" suffix="€" />
                        @if (hasConversion()) {
                          <small class="target-conversion">
                            ≈ {{ formatConverted(item.get('price')?.value) }} {{ targetCurrencyLabel }}
                          </small>
                        }
                      </div>
                      <div class="col-sm-2 maxw-field effort-field">
                        <div class="position-relative">
                          <input-field type="number" [inputFormControl]="getFormControl(item, 'discountPercent')"
                            label="Discount" placeholder="0" [readonly]="readonlyItems" [showWarning]="isDiscountWarning(item)"
                            suffix="%" />
                          @if (isDiscountWarning(item)) {
                            <button type="button" class="btn btn-sm btn-warning position-absolute"
                              style="top: 12px; right: -10px;" (click)="openDiscountNoteModal(item)">
                              <i class="fa fa-comment"></i>
                            </button>
                          }
                        </div>
                      </div>
                      <div class="col-sm-2 maxw-field effort-field">
                        <input-field type="number" [inputFormControl]="getFormControl(item, 'rankSale')" label="Rank Discount"
                          placeholder="0" [readonly]="readonlyItems" suffix="€" />
                        @if (hasConversion()) {
                          <small class="target-conversion">
                            ≈ {{ formatConverted(item.get('rankSale')?.value) }} {{ targetCurrencyLabel }}
                          </small>
                        }
                      </div>
                      <div class="col-sm-auto maxw-field final-price-field">
                        <div class="d-flex align-items-end">
                          <div class="w-100 me-2">
                            <input-field type="number" [inputFormControl]="getFormControl(item, 'finalPrice')" label="Final Price"
                              placeholder="600" [readonly]="readonlyItems" suffix="€" />
                          </div>
                          <button type="button" class="btn btn-outline-info btn-sm" style="height: 38px; width: 38px; margin-bottom: 1.25rem;"
                            (click)="openDetailsModal(item)" [disabled]="readonlyItems">
                            <i class="fa fa-info-circle"></i>
                          </button>
                        </div>
                        @if (hasConversion()) {
                          <small class="target-conversion">
                            ≈ {{ formatConverted(item.get('finalPrice')?.value) }} {{ targetCurrencyLabel }}
                          </small>
                        }
                      </div>
                    </div>
                  }
                </div>
                <div class="row align-items-center form-row">
                </div>
                @if (getFormArray(item, 'proposalItemLaws').controls.length > 0) {
                  <div class="mt-3">
                    <div class="row g-3 align-items-center mx-0 mb-2">
                      <div class="col-sm-10">
                        <span class="fw-bold">Law</span>
                      </div>
                      <div class="col-sm-2"></div>
                    </div>
                    @for (law of getFormArray(item, 'proposalItemLaws').controls; track law; let lawIndex = $index) {
                      <div
                        class="row g-3 align-items-center">
                        <div class="col-sm-10">
                          <select-field [selectFormControl]="getNestedFormControl(law, 'lawId')" label=""
                            [options]="getLawOptionsForItem(itemIndex)" [readonly]="readonlyItems"
                            (selectionChange)="updateLawName(law, itemIndex)" />
                        </div>
                        <div class="col-sm-2 d-flex mt-4 justify-content-center">
                          <button type="button" class="btn btn-danger" (click)="confirmDeleteLaw(item, lawIndex)"
                            [disabled]="readonlyItems" [ngClass]="{'disabled': readonlyItems}">
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (missingLawsByItem[itemIndex]) {
                  <div class="alert alert-danger py-2 mt-2 mb-2">
                    This item has no laws associated. Please add at least one law to continue.
                  </div>
                }
                @if (readonlyItems == false) {
                  <button type="button" class="btn btn-outline-primary mt-2"
                    (click)="addLaw(item)">
                    + Add Law
                  </button>
                }
              </div>
            }
          </div>
        }
      </form>
      @if (readonlyItems == false) {
        <div class="col-12 d-flex justify-content-center">
          <button type="button" class="btn btn-success me-3"
            [disabled]="saveItemsDisabled"
            [title]="isItemsLocked ? 'Save the proposal data first' : (saveItemsDisabled ? 'Add at least one item before saving' : '')"
            (click)="submitForm()">
            Save
          </button>
          <button type="button" class="btn btn-info"
            [disabled]="addItemDisabled"
            [title]="isItemsLocked ? 'Save the proposal data first' : ''"
            (click)="addNewItem()">
            <i class="fa fa-plus"></i> Add item
          </button>
        </div>
      }
    </div>
  </div>
}
@if (useDetailView) {
  <div class="card shadow-sm" #proposalItemsContainer>
    <div class="card-header d-flex justify-content-between align-items-center">
      <h3 class="card-title mb-0">Items</h3>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-striped table-bordered mb-0">
          <thead class="bg-light">
            <tr>
              <th class="text-center" style="width: 50px;">N.</th>
              <th>JURISDICTION</th>
              <th>PRODUCT</th>
              <th>TYPE</th>
              <th>PLATFORM</th>
              <th class="text-center">Q.TY</th>
              <th class="text-center">EFFORT</th>
              <th class="text-center">PRICE</th>
              <th class="text-center">RANK DSC.</th>
              <th class="text-center">DISCOUNT</th>
              <th class="text-center">PROMO</th>
              <th class="text-center">FINAL PRICE</th>
              <th class="text-center" style="width: 50px;"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item; let i = $index) {
              <tr>
                <td class="text-center">{{i + 1}}</td>
                <td>{{item.jurisdiction?.name}}</td>
                <td>{{item.itemProduct?.code}}</td>
                <td>{{item.itemType?.code}}</td>
                <td>{{item.platform?.code}}</td>
                <td class="text-center">{{item.quantity}}</td>
                <td class="text-center">{{item.effort}}%</td>
                <td class="text-center">{{item.price}}€</td>
                <td class="text-center">{{item.rankSale || 0}}</td>
                <td class="text-center">{{item.discountPercent || 0}}%</td>
                <td class="text-center">{{item.campaign?.name || '-'}}</td>
                <td class="text-center">{{item.finalPrice}}€</td>
                <td class="text-center">
                  <button type="button" class="btn btn-sm action-btn" (click)="toggleItemDetails(i)">
                    <i class="fa" [ngClass]="isItemExpanded(i) ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </button>
                </td>
              </tr>
              @if (isItemExpanded(i)) {
                <tr>
                  <td colspan="13" class="p-0">
                    <div class="expanded-details p-3 border-top">
                      <div class="row">
                        <div class="col-12">
                          <div class="table-responsive details-table">
                            <table class="table table-bordered">
                              <thead>
                                <tr>
                                  <th>DETAILS</th>
                                  <th>MAX DISCOUNT</th>
                                  <th>OPERATING COST</th>
                                  <th>INTRODUCER NAME</th>
                                  <th>INTRODUCER%</th>
                                  <th>INTRODUCER €</th>
                                  <th>MARGIN</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>{{item.detail || '-'}}</td>
                                  <td>{{item.maxDiscount || '-'}}</td>
                                  <td>{{item.operatingCost || '-'}}</td>
                                  <td>{{item.introducer?.name || 'N/A'}}</td>
                                  <td>{{item.introducerPercent || '0%'}}</td>
                                  <td>{{item.introducerValue || '0€'}}</td>
                                  <td>{{item.marginValue || '0€'}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="col-12 mt-3">
                          <h5 class="mb-3 fw-bold">Laws</h5>
                          @let itemLaws = getItemLaws(item);
                          <ul class="list-group law-list">
                            @for (lawItem of itemLaws; track lawItem.lawId) {
                              <li class="list-group-item">
                                {{lawItem.name || '-'}}
                              </li>
                            }
                            @empty {
                              <li class="list-group-item text-muted">
                                No laws specified
                              </li>
                            }
                          </ul>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            }
            @if (!items || items.length === 0) {
              <tr>
                <td colspan="13" class="text-center py-4">No items available</td>
              </tr>
            }
          </tbody>
          @if (items && items.length > 0) {
            <tfoot>
              <tr>
                <td colspan="11" class="text-end fw-bold">TOTAL:</td>
                <td class="text-center fw-bold total-value">{{ calculateTotal() }}€</td>
                <td></td>
              </tr>
            </tfoot>
          }
        </table>
      </div>
    </div>
  </div>
}

<ng-template #detailsModal let-modal>
  <div class="modal-header bg-primary text-white">
    <h5 class="modal-title">
      <i class="fa fa-info-circle me-2"></i> Field Details
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <tbody>
          <tr>
            <td><strong>Introducer Name</strong></td>
            <td class="text-center">{{ selectedItem?.introducerName }}</td>
          </tr>
          <tr>
            <td><strong>Max Discount</strong></td>
            <td class="text-center">{{ selectedItem?.maxDiscount }}</td>
          </tr>
          <tr>
            <td><strong>Operating Cost</strong></td>
            <td class="text-center">{{ selectedItem?.operatingCost }}</td>
          </tr>
          <tr>
            <td><strong>Introducer %</strong></td>
            <td class="text-center">{{ selectedItem?.introducerRate }} %</td>
          </tr>
          <tr>
            <td><strong>Introducer €</strong></td>
            <td class="text-center">{{ selectedItem?.introducerPrice }} €</td>
          </tr>
          <tr>
            <td><strong>Margin</strong></td>
            <td class="text-center">{{ selectedItem?.margin }} €</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      Close
    </button>
  </div>
</ng-template>

<ng-template #discountNoteModal let-modal>
  <div class="modal-header bg-warning text-dark">
    <h5 class="modal-title">
      <i class="fa fa-exclamation-triangle me-2"></i> Discount Warning
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="alert alert-warning">
      <strong>This discount is too high!</strong>
    </div>

    @if (discountWarningData?.campaignName) {
      <div>
        <p>The entered discount ({{ discountWarningData?.currentDiscount }}%) exceeds the maximum discount allowed by
        the campaign "{{ discountWarningData?.campaignName }}" ({{ discountWarningData?.maxDiscount }}%).</p>
      </div>
    }

    @if (!discountWarningData?.campaignName && discountWarningData?.maxDiscount) {
      <div>
        <p>The entered discount ({{ discountWarningData?.currentDiscount }}%) exceeds the maximum discount allowed ({{
        discountWarningData?.maxDiscount }}%).</p>
      </div>
    }

    <p class="mb-0">To continue, fill in why you need this value and tap 'request approval'</p>

    <div class="form-group mt-3">
      <label for="discountJustification" class="fw-bold">Justification</label>
      <textarea id="discountJustification" class="form-control" rows="3" [(ngModel)]="discountJustification"
      placeholder="Enter a justification for the approval request"></textarea>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      Close
    </button>
    <button type="button" class="btn btn-primary" (click)="requestDiscountApproval()"
      [disabled]="!discountJustification">
      Request Approval
    </button>
  </div>
</ng-template>

<div class="position-relative">
  @if (isLoading) {
    <loader [config]="loaderConfig"></loader>
  }

</div>